/* eslint complexity: 0 */
import request from 'superagent';

/**
 * Enhance the superagent "end" call to update the CSRF token from each response
 * (a modified implementation to https://github.com/zzarcon/superagent-serializer)
 * @param {Object} superagent
 * @return {void}
 */
const csrfSuperagent = (superagent) => {
    const Request = superagent.Request;
    const end = Request.prototype.end;

    Request.prototype.end = function(cb) {
        return end.call(this, (err, res) => {
            if (typeof res !== 'undefined') {
                /**
                 * A refreshed CSRF token is sent back with every request, so we
                 * need to store the new value for subsequent calls.
                 */
                if (res && res.header && res.header['x-csrf-jwt']) {
                    window.ha.csrfToken = res.header['x-csrf-jwt'];
                }
            }

            if (typeof cb === 'function') {
                cb(err, res);
            }
        });
    };
};

csrfSuperagent(request);

const agent = request.agent().use((req) => {
    /**
     * Include the CSRF token in the `x-csrf-jwt` header.
     * TODO: do we want to only attach x-csrf-jwt tokens for specific methods?
     */
    if (global.window && global.window.ha && global.window.ha.csrfToken) {
        req.set('x-csrf-jwt', window.ha.csrfToken);
    }
});

export default agent;
